import { ButtonLink, Icon } from '@pm/ui';
import { type ButtonLinkProps } from '@pm/ui/src/components/ButtonLink/ButtonLink';
import { useTranslation } from 'react-i18next';

type MagicLinkButtonProps = {
  intent?: ButtonLinkProps['intent'];
  search?: string;
};

export const MagicLinkButton = ({
  intent = 'secondary',
  search,
}: MagicLinkButtonProps) => {
  const { t } = useTranslation('global', { keyPrefix: 'Login' });

  return (
    <ButtonLink
      to={{ pathname: '/login/magic', search }}
      intent={intent}
      width="full"
      trailingIcon={<Icon name="mail" size="small" />}
    >
      {t('LoginWithLink')}
    </ButtonLink>
  );
};
